// Simulate a schedule from documents (back/routes/scheduleSimulation).
import { url, tokenRef } from "api";

const auth = () => {
  const t = localStorage.getItem(tokenRef);
  return t ? { Authorization: `Bearer ${t}` } : {};
};
const json = () => ({ "Content-Type": "application/json", ...auth() });
const handle = async (r) => {
  let d = {};
  try { d = await r.json(); } catch (e) { d = {}; }
  if (!r.ok) { const e = new Error(d.err || "Request failed"); e.status = r.status; e.code = d.code; throw e; }
  return d;
};
const base = (projectId) => `${url}/projects/${projectId}/schedule-simulations`;

export const listSimulationSources = async (projectId) => handle(await fetch(`${base(projectId)}/sources`, { headers: auth() }));
export const listSimulations = async (projectId) => handle(await fetch(base(projectId), { headers: auth() }));
export const getSimulation = async (projectId, id) => handle(await fetch(`${base(projectId)}/${id}`, { headers: auth() }));

/** files: File[]; documents / minutes: ids; options: { reforecastDays, packageDays, installDays } */
export const startSimulation = async (projectId, { files = [], documents = [], minutes = [], options = {} }) => {
  const fd = new FormData();
  files.forEach((f) => fd.append("files", f, f.name));
  fd.append("documents", JSON.stringify(documents));
  fd.append("minutes", JSON.stringify(minutes));
  fd.append("options", JSON.stringify(options));
  return handle(await fetch(base(projectId), { method: "POST", headers: auth(), body: fd }));
};
export const applySimulation = async (projectId, id, changes) =>
  handle(await fetch(`${base(projectId)}/${id}/apply`, { method: "POST", headers: json(), body: JSON.stringify({ changes }) }));
export const undoSimulation = async (projectId, id, force = false) =>
  handle(await fetch(`${base(projectId)}/${id}/undo`, { method: "POST", headers: json(), body: JSON.stringify({ force }) }));
export const retrySimulation = async (projectId, id) =>
  handle(await fetch(`${base(projectId)}/${id}/retry`, { method: "POST", headers: json() }));
export const dismissSimulation = async (projectId, id) =>
  handle(await fetch(`${base(projectId)}/${id}`, { method: "DELETE", headers: auth() }));
